import type { IPageInfoContent } from '@/types/PageInfo'
import type { ComposerTranslation } from 'vue-i18n'

type TranslationExists = (key: string) => boolean

/**
 * Ekran bilgisi metinleri resource'tan gelir: `{pageResource}_page_what` / `{pageResource}_page_why`.
 * İkisi de tanımlı değilse panel gösterilmez.
 */
export const getPageInfo = (
  pageResource: string | null | undefined,
  t: ComposerTranslation,
  te: TranslationExists,
): IPageInfoContent | null => {
  if (!pageResource) return null

  const [whatKey, whyKey] = [`${pageResource}_page_what`, `${pageResource}_page_why`]
  const what = te(whatKey) ? t(whatKey) : ''
  const why = te(whyKey) ? t(whyKey) : ''

  if (!what && !why) return null

  return { what, why }
}
